import * as ACTION_TYPES from '../types';

let initialState = {
  customerList: [],
  customer: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_CUSTOMERS:
        return {...state, customerList: action.data };

      case ACTION_TYPES.DELETE_CUSTOMER:
        let newList = state.customerList.filter(customer => customer._id !== action.id);
        return {...state, customerList: newList };
      
      case ACTION_TYPES.GET_CUSTOMER_BY_ID:
        return {...state, customer: action.data};

      case ACTION_TYPES.GET_CUSTOMERS_BY_CODE:
        return {...state, customerList: action.data };

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_CUSTOMER:
        return {...state, customerList: []};

      default:
        return state;
    }
  };